/// <amd-module name="Build/DesignerExtensions/ExtendsCheckPanel/Components/ExtendsWrapperComponent" />
import * as React from "react";

import { ExtendsCheckComponent } from "Build/DesignerExtensions/ExtendsCheckPanel/Components/ExtendsCheckComponent";
import { IExtendsCheckConfig, IExtendsCheckConfiguration, extendsCheckTypeId, extendsCheckTypeName } from "Build/DesignerExtensions/ExtendsCheckPanel/Components/ExtendsCheckConfig";
import * as Resources from "Build/DesignerExtensions/ExtendsCheckPanel/Resources";
import { CheckAction, ChecksTableCellRenderer, ICheckWrapperComponentProps } from "Checks/Client/Contracts/Contracts";
import { CheckConfiguration } from "Checks/Client/Contracts/PipelinesChecks";
import { equals, format } from "VSS/Core/Util/String";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { Tooltip } from "VSSUI/TooltipEx";

export class ExtendsWrapperComponent extends VssComponent<ICheckWrapperComponentProps> {

    public render(): JSX.Element {
        if (this.props.checkConfigObject) {
            this._extendsCheckConfigObject = this.props.checkConfigObject as IExtendsCheckConfiguration;
            if (!equals(this._extendsCheckConfigObject.type.id, extendsCheckTypeId, true)) {
                return <div />;
            }
        }
        else {
            this._extendsCheckConfigObject = {
                type: {
                    id: extendsCheckTypeId,
                    name: extendsCheckTypeName
                },
                resource: this.props.resource,
            } as IExtendsCheckConfiguration;
        }

        if (!this._extendsCheckConfigObject.settings) {
            let settings: IExtendsCheckConfig = {
                extendsChecks: []
            };
            this._extendsCheckConfigObject.settings = settings;
        }

        if (this.props.checkTableCellToRender !== undefined && this.props.checkConfigObject) {
            return this.renderCheckTableCell(this.props.checkTableCellToRender);
        }
        else if (this.props.checkAction === CheckAction.Create || this.props.checkAction === CheckAction.Edit) {
            return (
                <ExtendsCheckComponent
                    extendsChecks={this._extendsCheckConfigObject.settings.extendsChecks}
                    checkAction={this.props.checkAction}
                    {
                        ...this._getCommonProps()
                    }
                    />
            );
        }
        return <div />;
    }

    private renderCheckTableCell(checkTableCell: ChecksTableCellRenderer): JSX.Element {
        switch (checkTableCell) {
            case ChecksTableCellRenderer.DisplayName:
                return this._renderDisplayNameCell();
            case ChecksTableCellRenderer.Details:
                return this._renderDetailsCell();
            default:
                return <div />;
        }
    }

    private _renderDisplayNameCell(): JSX.Element {
        const displayName = Resources.DisplayName;
        return (
            <Tooltip text={displayName}>
                <div className="body-m primary-text">
                    {displayName}
                </div>
            </Tooltip>
        );
    }

    private _renderDetailsCell(): JSX.Element {
        if (this._extendsCheckConfigObject && this._extendsCheckConfigObject.settings && this._extendsCheckConfigObject.settings.extendsChecks)
        {
            const checks = this._extendsCheckConfigObject.settings.extendsChecks;
            if (checks.length === 1) {
                return (
                    <div className="list-content flex-column flex-grow scroll-hidden">
                        <div className="flex-row flex-grow flex-center">
                            <span className="body-m text-ellipsis">{checks[0].templatePath}</span>
                        </div>
                        <span className="body-s secondary-text">{`${checks[0].repositoryName} (${checks[0].repositoryRef})`}</span>
                    </div>);
            }
            else {
                return (<span>{format(Resources.DetailsMultiple, checks.length)}</span>);
            }
        }
        return <span></span>;
    }

    private _getCommonProps = () => {
        return ({
            resource: this.props.resource,
            disableCreateButton: this.props.disableCreateButton ? this.props.disableCreateButton : (val: boolean) => { },
            updateCheckDataAndEnableSave: this.props.updateCheckDataAndEnableSave ? this.props.updateCheckDataAndEnableSave : (val: CheckConfiguration) => { },
            updateTelemetryData: this.props.updateTelemetryData ? this.props.updateTelemetryData : (val: { [key: string ]: string }) => {}
        });
    }

    private _extendsCheckConfigObject: IExtendsCheckConfiguration;
}

Components.add("extends-check-view", ExtendsWrapperComponent);
